const updateSite = (payload) => {
    return {
        type: 'url/UPDATE_SITE',
        payload
    }
}

// Add more actions as necessary here
export const showLoader = ()=> dispatch=> {
    dispatchEvent({
        type:"SHOW_LOADER"
    })
}

export const hideLoader = ()=> dispatch=> {
    dispatchEvent({
        type:"HIDE_LOADER"
    })
}
export { updateSite }